import Title from '@cohort/components-xps/components/Title';
import PrimaryButton from '@cohort/wallet/components/button/PrimaryButton';
import BaseModal from '@cohort/wallet/components/modals/BaseModal';
import {Subtitle} from '@cohort/wallet/components/Subtitle';
import {CheckCircle} from '@phosphor-icons/react';
import {useTranslation} from 'react-i18next';

type JourneyOptInSuccessProps = {
  campaignId: string;
  onClose: () => void;
};

const JourneyOptInSuccess: React.FC<JourneyOptInSuccessProps> = ({campaignId, onClose}) => {
  const {t} = useTranslation('components', {keyPrefix: 'modals.journeys.journeyOptInSuccess'});

  return (
    <BaseModal
      title={
        <div className="flex w-full flex-col items-center justify-center gap-2">
          <CheckCircle className="h-8 w-8" />
          <Title content={t('title')} classes="text-xl font-semibold !w-auto" />
        </div>
      }
      subtitle={
        <div className="text-center">
          <Subtitle content={t('subtitle')} classes="!text-base font-medium" />
        </div>
      }
      tracking={{namespace: 'modals.journeys.optInSuccess'}}
    >
      <div className="text-center">
        <PrimaryButton
          text={t('cta')}
          type="button"
          tracking={{
            namespace: 'modals.journeys.optInSuccess.close',
            metadata: {
              journeyId: campaignId,
            },
          }}
          onClick={onClose}
        />
      </div>
    </BaseModal>
  );
};

export default JourneyOptInSuccess;
